import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { ReportActivitiesList } from "../../../../ReportActivities"

export default function OrganizationReportActivitiesPage() {
	return (
		<>
			<Helmet>
				<title>Report Activities</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<ReportActivitiesList />
			</ForbidUnlessAuthorized>
		</>
	)
}
